import React, { useState } from 'react';
import './StatusBar.css'; // Asegúrate de crear e importar el archivo CSS
import 'bootstrap-icons/font/bootstrap-icons.css'; // Importa los íconos

// Lista de los estados de la barra de progreso
const ESTATUS = [
  "Autorizado para CAS",
  "Recibido para diagnóstico",
  "Pendiente de aprobación",
  "Reparación Aprobada",
  "Listo para despacho",
  "Despachado",
  "Recibido a satisfacción"
];

const SPECIAL_STEPS = ["Reparación Aprobada", "Recibido a satisfacción"];

const StatusBar = ({ currentStep, onStepClick }) => {
  // Estado para saber sobre qué nodo está el cursor
  const [hoveredStep, setHoveredStep] = useState(null);

  // Calculamos el progreso para la línea de color verde
  const progressPercentage = ((currentStep - 1) / (ESTATUS.length - 1)) * 100;

  const handleStepClick = (step, statusName) => {
    // Solo ejecuta la función si el paso es el siguiente al actual
   
    if (step === currentStep + 1) {
      onStepClick(step, statusName);
    }
  };

  return (
    <div className="status-bar-container my-4">
      <div className="status-bar-progress" style={{ width: `${progressPercentage}%` }}></div>
      <div className="status-bar-nodes">
        {ESTATUS.map((status, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;
          const isNextStep = stepNumber === currentStep + 1;
          
          // El estado de vista previa se activa cuando el cursor está sobre el siguiente paso
          const isPreview = isNextStep && hoveredStep === stepNumber;
           const isSpecial = SPECIAL_STEPS.includes(status);

          // Clases dinámicas para el círculo
          const circleClasses = `node-circle 
            ${isCompleted || isPreview ? 'completed' : ''} 
            ${isActive ? 'active' : ''}
            ${isSpecial ? 'special-step-circle' : ''}
          `;
          
          // Clases dinámicas para el nodo completo (para el cursor)
          const nodeClasses = `status-node ${isNextStep ? 'clickable' : ''}`;
          const labelClasses = `node-label ${isSpecial ? 'special-step-label' : ''}`;

          return (
            <div
              className={nodeClasses}
              key={stepNumber}
              onClick={() => handleStepClick(stepNumber,ESTATUS[stepNumber - 1])}
              onMouseEnter={() => isNextStep && setHoveredStep(stepNumber)}
              onMouseLeave={() => isNextStep && setHoveredStep(null)}
            >
              <div className={circleClasses}>
                {/* Muestra el check si está completado o en vista previa */}
                {(isCompleted || isPreview) && <i className="bi bi-check"></i>}
                {/* Muestra el punto interior si es el paso activo */}
                {isActive && <div className="inner-circle"></div>}
              </div>
               <div className={labelClasses}>{status}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatusBar;